import ResizableHandle from "./components/handle";
import ResizablePanel from "./components/panel";
import ResizablePanelGroup from "./components/panelGroup";

const Resizable = {
    PanelGroup: ResizablePanelGroup,
    Handle: ResizableHandle,
    Panel: ResizablePanel
};
export default Resizable;
